import React from 'react';
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET_BY_PUBLISHER_ID } from "../../../../queries/settings";

const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updateSetting } }) => {
        setTimeout(()=>{
        const { settingByPublisherId } = cache.readQuery({ query: GET_BY_PUBLISHER_ID, variables:{ publisherId : props.publisherId }});
        cache.writeQuery({
          query: GET_BY_PUBLISHER_ID,
          variables: { publisherId : props.publisherId },
          data: { settingByPublisherId: settingByPublisherId }
        });
      }, 3000);
      }}
      refetchQueries={[
        {query:GET_BY_PUBLISHER_ID, variables: { publisherId : props.publisherId }}
      ]}
      awaitRefetchQueries={true}
      >
      {updateSetting => (
        <Form query_f = {updateSetting} {...props} />
      )}
    </Mutation>
  );
};

export default Update;